{
    "sign_in": "تسجيل الدخول",
    "sign_out": "تسجيل الخروج",
    "title": "تسجيل الدخول إلى حسابك",
    "subtitle": "استخدم بيانات اعتماد البنك للمتابعة.",
    "identifier": "البريد الإلكتروني أو الرقم الوظيفي",
    "identifier_placeholder": "name@developmentbank.om",
    "password": "كلمة المرور",
    "remember": "أبقِني مسجّلاً",
    "forgot": "هل نسيت كلمة المرور؟",
    "submit": "تسجيل الدخول",
    "signing_in": "جارٍ تسجيل الدخول…",
    "demo_heading": "شخصيات العرض التوضيحي",
    "demo_description": "اختر دوراً للدخول مباشرةً. متاح في وضع العرض فقط.",
    "demo_password_note": "تستخدم جميع حسابات العرض كلمة المرور {{password}}.",
    "session_expired_title": "انتهت جلستك",
    "session_expired_body": "تم تسجيل خروجك بعد فترة من عدم النشاط. سجّل الدخول مجدداً للمتابعة من حيث توقفت.",
    "two_factor_title": "التحقق بخطوتين",
    "two_factor_body": "أدخل الرمز المكوّن من ستة أرقام من تطبيق المصادقة.",
    "two_factor_code": "رمز التحقق",
    "two_factor_recovery": "استخدام رمز استرداد بدلاً من ذلك",
    "password_expired_title": "انتهت صلاحية كلمة المرور",
    "password_expired_body": "اختر كلمة مرور جديدة للمتابعة.",
    "current_password": "كلمة المرور الحالية",
    "new_password": "كلمة المرور الجديدة",
    "confirm_password": "تأكيد كلمة المرور",
    "welcome_back": "أهلاً بعودتك"
}
